__turbopack_context__.v({
  "address-text": "_6HGq1W_address-text",
  "callme-text": "_6HGq1W_callme-text",
  "consumer-complaint": "_6HGq1W_consumer-complaint",
  "consumer-complaint-contact": "_6HGq1W_consumer-complaint-contact",
  "consumer-complaint-detail": "_6HGq1W_consumer-complaint-detail",
  "consumer-complaint-title": "_6HGq1W_consumer-complaint-title",
  "contact-wrap": "_6HGq1W_contact-wrap",
  "container-page": "_6HGq1W_container-page",
  "form-contact-us-wrap": "_6HGq1W_form-contact-us-wrap",
  "form-greeting": "_6HGq1W_form-greeting",
  "image-slider": "_6HGq1W_image-slider",
  "image-text": "_6HGq1W_image-text",
  "image-wrap": "_6HGq1W_image-wrap",
  "main-office-text": "_6HGq1W_main-office-text",
  "office-area-name-text": "_6HGq1W_office-area-name-text",
  "office-content": "_6HGq1W_office-content",
  "wrap-office-area": "_6HGq1W_wrap-office-area",
});
